import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Confirm', cancelText = 'Cancel', type = 'danger' }) => {
    if (!isOpen) return null;

    return (
        <div className="conf-modal-overlay" onClick={onCancel}>
            <div className="conf-modal-container" onClick={e => e.stopPropagation()}>
                <div className="conf-modal-content">
                    <h3 className="conf-modal-title">{title}</h3>
                    <p className="conf-modal-body">{message}</p>
                    <div className="conf-modal-actions">
                        <button className="conf-modal-btn btn-cancel" onClick={onCancel}>{cancelText}</button>
                        <button className={`conf-modal-btn btn-${type}`} onClick={onConfirm}>{confirmText}</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
